import { MortgageDataItem } from "../Components/RateGraph/MortgageGraph";
import { FinansPortalen } from "../api/BankService";

export const extractDealAndCreateDiplayName = (deal:FinansPortalen):MortgageDataItem => {
    let displayDeal = {
        name: `${deal.ProductName}`,
        interestRate: deal.Int_Nominal
    }
    return displayDeal;
}